module.exports = __webpack_public_path__ + "static/media/fullstack.fce60807.svg";